import * as Yup from "yup";

// Email validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// UK Phone number regex (supports +44 and 07 formats)
const ukPhoneRegex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;

/**
 * Validation schema for organization details form
 */
export const organizationDetailsValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Organisation name must be at least 2 characters")
    .max(255, "Organisation name must not exceed 255 characters")
    .test(
      "no-leading-trailing-spaces",
      "Organisation name cannot have leading or trailing spaces",
      (value) => !value || value === value.trim(),
    ),

  companyName: Yup.string()
    .min(2, "Company name must be at least 2 characters")
    .max(255, "Company name must not exceed 255 characters")
    .test(
      "no-leading-trailing-spaces",
      "Company name cannot have leading or trailing spaces",
      (value) => !value || value === value.trim(),
    ),

  companyEmail: Yup.string()
    .matches(emailRegex, "Please enter a valid email address")
    .email("Please enter a valid email address"),

  companyTelephone: Yup.string().test(
    "is-valid-phone",
    "Please enter a valid UK phone number (e.g., +447123456789 or 07123456789)",
    (value) => {
      if (!value) return true; // Allow empty values
      // Remove spaces and check format
      const cleaned = value.replace(/\s/g, "");

      return ukPhoneRegex.test(value) || /^\+44\d{10}$/.test(cleaned) || /^07\d{9}$/.test(cleaned);
    },
  ),

  primaryContactName: Yup.string()
    .min(2, "Primary contact name must be at least 2 characters")
    .max(255, "Primary contact name must not exceed 255 characters")
    .test(
      "no-leading-trailing-spaces",
      "Primary contact name cannot have leading or trailing spaces",
      (value) => !value || value === value.trim(),
    ),

  primaryContactEmail: Yup.string()
    .matches(emailRegex, "Please enter a valid email address")
    .email("Please enter a valid email address"),

  primaryContactTelephone: Yup.string().test(
    "is-valid-phone",
    "Please enter a valid UK phone number (e.g., +447123456789 or 07123456789)",
    (value) => {
      if (!value) return true; // Allow empty values
      const cleaned = value.replace(/\s/g, "");

      return ukPhoneRegex.test(value) || /^\+44\d{10}$/.test(cleaned) || /^07\d{9}$/.test(cleaned);
    },
  ),

  // phone: Yup.string()
  //   .required("Phone number is required")
  //   .test(
  //     "is-valid-phone",
  //     "Please enter a valid UK phone number (e.g., +447123456789 or 07123456789)",
  //     (value) => {
  //       if (!value) return false;
  //       const cleaned = value.replace(/\s/g, "");

  //       return (
  //         ukPhoneRegex.test(value) || /^\+44\d{10}$/.test(cleaned) || /^07\d{9}$/.test(cleaned)
  //       );
  //     },
  //   ),
});
